import dayjs from 'dayjs';
import { all, delay, fork, put, takeLeading } from 'redux-saga/effects';
import ApiConstants from 'src/common/helpers/ApiConstants';
import * as requests from '../../helpers/HTTPRequest';
import * as Actions from './actions';

function* fetchGraphDataSaga({ payload, callback }) {
  try {

    const { devices, from, to, startTime, endTime } = payload;

    const startParam = dayjs(`${from} ${startTime}`).format('YYYY-MM-DD HH:mm');
    const endParam = dayjs(`${to} ${endTime}`).format('YYYY-MM-DD HH:mm');

    const tasks = [];
    for (const device of devices) {
      const { deviceId, channels } = device;
      const selectedChannels = channels
        .filter((c) => [0, 1, 2].includes(c.dataType))
        .map((x) => x.channelId);
      const channelsParam = selectedChannels.join('&channelIds=');

      const url = `${ApiConstants.BASE_URL}${ApiConstants.DATA_VIEW}?type=raw&start=${startParam}&end=${endParam}&deviceId=${deviceId}&channelIds=${channelsParam}`;
      tasks.push(requests.getRequest(url, {}));
    }

    const responses = yield Promise.all(tasks);

    const graphDataSets = {};
    devices.forEach((device, index) => {
      const deviceData = responses[index];
      Object.entries(deviceData).forEach(([channelId, channelData]) => {
        if (!channelData.length) {
          return;
        }
        const channelKey = `${device.deviceId}_${channelId}`;
        graphDataSets[channelKey] = [];

        channelData.map((point) => {
          const t = new Date(point.date || point.timestamp);
          graphDataSets[channelKey].push([
            new Date(t),
            parseFloat(Number(point.value).toRoundString(2)),
          ]);
        });
      });
    });

    yield put(
      Actions.fetchGraphDataSuccess({
        data: graphDataSets,
      })
    );
    callback();
  } catch (e) {
    console.log('error', e);
    // When device id unregistered. Reload devices...
    // if (e.status === 404) {
    //   const currentDevices = yield select((state) => state.UnitsChannels.units);
    //   const deviceIdUnregistered = e.data?.deviceIdUnregistered || '';
    //   const dv = currentDevices.find(
    //     (item) => item.deviceId === deviceIdUnregistered
    //   );
    //   const deviceName =
    //     dv && dv.name
    //       ? dv.name
    //       : `${TextConstants.Common.NoName}(id: ${deviceIdUnregistered})`;
    //   toastWarning(
    //     `${e.message}${TextConstants.Common.DeviceNotRegistered}${deviceName}。`
    //   );
    //   yield put(fetchUnits());
    // } else if (e.status === 504) {
    //   // "Endpoint request timed out"
    //   yield put(
    //     Actions.fetchGraphDataError({
    //       message: TextConstants.DataView.EndpointTimeOutError,
    //     })
    //   );
    // } else {
    //   yield put(
    //     Actions.fetchGraphDataError({ message: e?.message || 'loading failed' })
    //   );
    // }
  } finally {
    yield delay(1000);
    yield put(Actions.fetchGraphDataCleanState());
  }
}

export function* watchMultiGraphSagas() {
  yield takeLeading(
    Actions.multiGraphActions.FETCH_GRAPH_DATA,
    fetchGraphDataSaga
  );
}

export default function* rootSaga() {
  yield all([fork(watchMultiGraphSagas)]);
}
